export const translations = {
  ru: {
    TITLE: "Уведомления",
    EMPTY_LIST_CONTENT: "Новых уведомлений нет",
    ARIA_LABELS: {
      NOTIFICATION_SERVICES_BUTTON: "Настройка уведомлений",
      CLOSE_NOTIFICATIONS: "Закрыть уведомления",
    },
    REDIRECT_BUTTON_TEXT: "Перейти в раздел",
    IMPORTANT_MARK_TEXT: "Важное",
    DETAILS_BUTTON_LINK_TEXT: "Подробнее",
    UTILS: {
      MONTHS: [
        "января",
        "февраля",
        "марта",
        "апреля",
        "мая",
        "июня",
        "июля",
        "августа",
        "сентября",
        "октября",
        "ноября",
        "декабря",
      ],
      TODAY_TITLE: "Сегодня",
    },
  },
  en: {
    TITLE: "Notifications",
    EMPTY_LIST_CONTENT: "No new notifications",
    ARIA_LABELS: {
      NOTIFICATION_SERVICES_BUTTON: "Notification settings",
      CLOSE_NOTIFICATIONS: "Close notifications",
    },
    REDIRECT_BUTTON_TEXT: "Go to section",
    IMPORTANT_MARK_TEXT: "Important",
    DETAILS_BUTTON_LINK_TEXT: "More",
    UTILS: {
      MONTHS: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      TODAY_TITLE: "Today",
    },
  },
} as const;
